/** Marks the box a form scrolls in as the place its popups belong. */
export const POPUP_SCOPE_ATTR = "data-popup-scope"

/**
 * Where AntD should mount a popup opened from inside a scrolling form.
 *
 * Resolved from the trigger rather than by selector: the modal around these
 * forms holds more than one scrollable box, and only the innermost one moves
 * the field.
 */
export const popupContainerWithinScope = (trigger?: HTMLElement): HTMLElement =>
  // Modal calls a ConfigProvider-level container with no node at all, so the
  // fallback is load-bearing rather than defensive.
  (trigger?.closest(`[${POPUP_SCOPE_ATTR}]`) as HTMLElement | null) ??
  document.body
